import { useTheme, useMediaQuery } from "@mui/material";

/**
 * Hook to determine if the current viewport should show the mobile view.
 *
 * Uses the sm breakpoint (600px) - mobile view only shown on phones,
 * tablets always show the desktop table view.
 */
export const useResponsiveView = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	return { isMobile };
};
